import { apiRequest } from "./client";

export type ExamFormat = "in_person" | "online";
export type ExamScheduleStatus = "scheduled" | "completed" | "cancelled";

export interface ExamScheduleOut {
  id: number;
  trainee_user_id: number;
  course_id: number;
  examiner_user_id: number | null;
  scheduled_at: string;
  format: ExamFormat;
  status: ExamScheduleStatus;
  comment: string | null;
  created_at: string;
}

export interface ScheduleExamPayload {
  trainee_user_id: number;
  course_id: number;
  examiner_user_id?: number | null;
  scheduled_at: string;
  format?: ExamFormat;
  comment?: string | null;
}

export function listMyExams(): Promise<ExamScheduleOut[]> {
  return apiRequest<ExamScheduleOut[]>("/exam-schedules/me");
}

export function upcomingExam(): Promise<ExamScheduleOut | null> {
  return apiRequest<ExamScheduleOut | null>("/exam-schedules/me/upcoming");
}

export function listExamsForUser(userId: number): Promise<ExamScheduleOut[]> {
  return apiRequest<ExamScheduleOut[]>(`/exam-schedules/users/${userId}`);
}

export function scheduleExam(
  payload: ScheduleExamPayload,
): Promise<ExamScheduleOut> {
  return apiRequest<ExamScheduleOut>("/exam-schedules", {
    method: "POST",
    body: payload,
  });
}

export function cancelExam(id: number): Promise<ExamScheduleOut> {
  return apiRequest<ExamScheduleOut>(`/exam-schedules/${id}/cancel`, {
    method: "POST",
  });
}

export function completeExam(id: number): Promise<ExamScheduleOut> {
  return apiRequest<ExamScheduleOut>(`/exam-schedules/${id}/complete`, {
    method: "POST",
  });
}
